import axios from 'axios';
import { AxiosResponse, AxiosError } from 'axios';

let url: string = 'https://pokeapi.co/api/v2/pokemon/ditto/';
let headers = {
  'Content-type': 'application/json',
  Accept: 'application/json',
};

export const request = (method: any, customUrl?: string, data?: any) => {

  if (customUrl) url = customUrl;
  
  return axios({
    method: method,
    url: url,
    data: data,
    headers: headers,
  })
  .then((response: AxiosResponse) => {
    return response;
  })
  .catch((error: AxiosError) => {
    return error;
  });
};